'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    UserStore = require('./UserStore'),
    update = require('react/lib/update'),
    { createStore, mergeIntoBag, isInBag } = require('../utils/StoreUtils');

var _zines = {};

var ZineStore = createStore({
  contains(slug, fields) {
    return isInBag(_zines, slug, fields);
  },

  get(slug) {
    return _zines[slug];
  }
});

ZineStore.dispatchToken = AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([UserStore.dispatchToken]);

  var action = payload.action,
      slug = action.zineSlug,
      response = action.response,
      entities = response && response.entities,
      receivedZines = entities && entities.zines;

  switch (action.type) {
  case ActionTypes.FOLLOW_ZINE:
  case ActionTypes.UNFOLLOW_ZINE_ERROR:
    _zines[slug] = update(_zines[slug], {
      isSubscribed: {
        $set: true
      },
      subscriberCount: {
        $apply: subscriberCount => subscriberCount + 1
      }
    });
    ZineStore.emitChange();
    break;

  case ActionTypes.UNFOLLOW_ZINE:
  case ActionTypes.FOLLOW_ZINE_ERROR:
    _zines[slug] = update(_zines[slug], {
      isSubscribed: {
        $set: false
      },
      subscriberCount: {
        $apply: subscriberCount => subscriberCount - 1
      }
    });
    ZineStore.emitChange();
    break;

  case ActionTypes.APPROVE_STAMP_TO_ZINE_SUCCESS:
  case ActionTypes.REJECT_STAMP_FROM_ZINE_SUCCESS:
    _zines[slug] = update(_zines[slug], {
      pendingCount: {
        $apply: pendingCount => pendingCount - 1
      }
    });
    ZineStore.emitChange();
    break;
  }

  if (receivedZines) {
    mergeIntoBag(_zines, receivedZines);
    ZineStore.emitChange();
  }
});

module.exports = ZineStore;


/** WEBPACK FOOTER **
 ** ./stores/ZineStore.js
 **/